// Bumped with every deployed change batch (date + counter within the day) so
// the on-screen stamp shows whether the browser has the latest bundle.
export const APP_VERSION = 'v2026.10.22.1';
